<script>
  import { onMount } from "svelte";
  import { makeWebsiteRequest } from "../../Common/tools";

  import Table from "../../Table/Table.svelte";
  import {External, M} from "../../external";

  export let filters = [],
    funnel = null,
    period = null;

  export function reload() {
    load(0);
  }

  let source = "utm_source",
    loading = true,
    initialLoad = true,
    currentPage = 0,
    pagesCount = 0,
    itemsCount = 0,
    table = null,
    allOrdersTotal = 0,
    allOrdersCount = 0;

  let tableColumns = [
    { key: "source", label: M.SOURCES, class: "flex-1 mw-240", style: "font-size: 15px" },
    { key: "count", label: M.ORDERS, class: "flex-none mw-140", style: "font-size: 15px" },
    { key: "total", label: M.REVENUE, class: "flex-none mw-140", style: "font-size: 15px" },
    { key: "ofAll", label: M.PERCENT_OF_REVENUE, class: "flex-none mw-140", type: "progressbar" }
  ];

  let tableData = {
    columns: tableColumns,
    rows: []
  };

  let load = async (page) => {
    if (loading && !initialLoad) {
      return;
    }
    initialLoad = false;

    if (page === 0) {
      tableData.rows = [];
    } else if (currentPage + 1 >= pagesCount) {
      return;
    }
    loading = true;

    let response = await makeWebsiteRequest({
      action: "getOrderStats",
      method: "post",
      data: {
        type: "top-performers",
        grouping: "sources:" + source,
        funnel: funnel,
        page: page,
        from: period && period.from ? External.Tools.dateToISOStr(period.from) : null,
        to: period && period.to ? External.Tools.dateToISOStr(period.to) : null,
        filters: JSON.stringify(filters)
      }
    });

    loading = false;
    if (!response.data) return;

    let sources = response.data.sources;

    currentPage = page;
    pagesCount = sources.pagesCount;
    itemsCount = sources.count;

    if (page === 0) {
      allOrdersCount = response.data.orders;
      allOrdersTotal = response.data.sales;
    }

    sources.items.forEach((item) => {
      item.ofAll = item.total / allOrdersTotal;
      item.total = External.Tools.currencyToStrWithSymbol(item.total);
    });

    if (table) {
      table.addRows(sources.items);
    }
  };

  let onNext = () => {
    load(currentPage + 1);
  };

  let changeTab = (newSource) => {
    if (newSource === source) {
      return;
    }
    source = newSource;
    load(0);
  };

  onMount(() => {
    load(0);
  });
</script>

<div class="col20 f-left flex mt-25 flex-col-mobile">
  <div class="side-filter">
    <li class:active={source === "utm_source"}><a on:click={() => changeTab("utm_source")}>{M.SOURCE}<br><p class="utm-table-text">UTM_SOURCE</p></a></li>
    <li class:active={source === "utm_campaign"}><a on:click={() => changeTab("utm_campaign")}>{M.CAMPAIGN}<br><p class="utm-table-text">UTM_CAMPAIGN</p></a></li>
    <li class:active={source === "utm_medium"}><a on:click={() => changeTab("utm_medium")}>{M.UTM_MEDIUM}<br><p class="utm-table-text">UTM_MEDIUM</p></a></li>
    <li class:active={source === "utm_content"}><a on:click={() => changeTab("utm_content")}>{M.CONTENT}<br><p class="utm-table-text">UTM_CONTENT</p></a></li>
    <li class:active={source === "utm_term"}><a on:click={() => changeTab("utm_term")}>{M.TERM}<br><p class="utm-table-text">UTM_TERM</p></a></li>
  </div>
  <Table
    bind:this={table}
    hasSelection={false}
    activeColumns={tableData.columns}
    data={tableData.rows}
    loading={loading}
    hideHeadOnLoad={true}
    nextPage={onNext}
    tableClass={"orders-scrollable-table"}>
    <div class="col20 f-left coming-soon-block">
      <div class="col20 f-left t-center mb-25">
        <span class="material-icons-outlined fingerprint-icon" style="background: #f5f6fa;"> bubble_chart </span>
      </div>
      <div class="col20 f-left t-center">
        <h3>{M.NO_DATA_YET}</h3>
      </div>
    </div>
  </Table>
</div>
